module.exports = __webpack_public_path__ + "images/emoji/person_frowning.4bd465a64d951b7b7740.png";